module.exports = __webpack_public_path__ + "static/media/intro.b09d0e15.gif";